module.exports = (__parcel__import__("k4CHn")).then(() => parcelRequire('8dRFe'));